export default function getUrlParameters() {
  const searchParams = new URLSearchParams(window.location.search);
  let params = {};

  if (searchParams.has("defaultCulture")) {
    params.defaultCulture = searchParams.get("defaultCulture");
  } else {
    params.defaultCulture = process.env.VUE_APP_I18N_FALLBACK_LOCALE;
  }

  if (searchParams.has("availableCultures")) {
    params.availableCultures = searchParams.getAll("availableCultures");
  } else {
    params.availableCultures = [process.env.VUE_APP_I18N_FALLBACK_LOCALE];
  }

  if (searchParams.has("uiCulture")) {
    params.uiCulture = searchParams.getAll("uiCulture");
  } else {
    params.uiCulture = params.defaultCulture;
  }

  if (!params.availableCultures.includes(params.defaultCulture)) {
    params.availableCultures.push(params.defaultCulture);
  }
  params.availableCultures.sort();

  if (searchParams.has("seriesId")) {
    params.seriesID = searchParams.get("seriesId");
  }

  if (searchParams.has("token")) {
    params.token = searchParams.get("token");
  }

  if (searchParams.has("product")) {
    params.product = searchParams.get("product").toLowerCase();
  } else {
    params.product = "blue";
  }

  if (searchParams.has("libraryId")) {
    params.libraryId = searchParams.get("libraryId");
  } else {
    params.libraryId = "";
  }

  if (searchParams.has("tagsLink")) {
    params.tagsLink = searchParams.get("tagsLink");
  } else {
    params.tagsLink = "";
  }

  return params;
}
